import Swiper from "swiper";
import { Navigation, A11y, Keyboard, Pagination } from "swiper/modules";

const adjustContainer = (cID) => {
  let container = document.querySelector(`#${cID}`);
  let wWidth = window.innerWidth;

  if (wWidth > 575) {
    let pAddOffset = 0;
    if (wWidth >= 991 && wWidth < 1400) {
      pAddOffset = 45;
    } else if (wWidth >= 1400) {
      pAddOffset = 65;
    }

    let combinedOffset = 80 + pAddOffset;
    let containerOffset = (wWidth - container.offsetWidth) / 2 - 80;
    if (containerOffset < 0) containerOffset = 0;

    container.style.paddingLeft = `${combinedOffset}px`;
    container.style.paddingRight = `${combinedOffset}px`;
    container.style.marginLeft = `${containerOffset}px`;
    container.style.marginRight = 0;
    container.style.maxWidth = `calc(100% - ${containerOffset}px)`;
  } else {
    container.removeAttribute("style");
  }
};

export const init = function (callback) {
  let swiperContainers = document.querySelectorAll(".swiper-container--5");

  swiperContainers.forEach(function (swiperContainer) {
    let cID = swiperContainer.getAttribute("id");
    let id = swiperContainer.querySelector(".swiper").getAttribute("id");
    let cSlider = document.querySelector(`#${cID} .content-slider--5`);

    let swiper = new Swiper(`#${id}`, {
      modules: [Navigation, Keyboard, A11y, Pagination],
      speed: 500,
      rewind: true,
      slidesOffsetAfter: 0,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      pagination: {
        el: `#${cID} .swiper-pagination`,
        clickable: true,
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      breakpoints: {
        768: {
          slidesOffsetAfter: 90,
        },
        991: {
          slidesOffsetAfter: 0,
        },
      },
      on: {
        afterInit: function () {
          document.querySelector(`#${cID}`).classList.add("slider-init");
          cSlider.classList.add("slider-initialized");
        },
        lock: function (swiper) {
          document.querySelector(`#${cID}`).classList.add("slider-lock");
          cSlider.style.paddingBottom = "0";
        },
        unlock: function (swiper) {
          document.querySelector(`#${cID}`).classList.remove("slider-lock");
          cSlider.removeAttribute("style");
        },
      },
    });

    document
      .querySelector(`#${cID} .arrow--next`)
      .addEventListener("click", function () {
        swiper.slideNext();
      });

    document
      .querySelector(`#${cID} .arrow--prev`)
      .addEventListener("click", function () {
        swiper.slidePrev();
      });

    adjustContainer(cID);

    window.addEventListener("resize", function () {
      adjustContainer(cID);
    });
  });
};
